<script setup lang="ts">
import { ref, onErrorCaptured } from 'vue'
import { AlertTriangle } from '@lucide/vue'
import BaseButton from './BaseButton.vue'

const hasError = ref(false)
const componentKey = ref(0)

onErrorCaptured((err, _vm, info) => {
  hasError.value = true
  console.error('[AppErrorBoundary]', err, info)
  return false
})

function handleReload() {
  hasError.value = false
  componentKey.value++
}
</script>

<template>
  <div
    v-if="hasError"
    data-testid="app-error-boundary"
    class="min-h-dvh flex items-center justify-center bg-bg-page px-4 py-12"
  >
    <div class="text-center max-w-md bg-surface rounded-card p-10 border border-border-standard">
      <div class="w-20 h-20 bg-error-bg rounded-full flex items-center justify-center mx-auto mb-6">
        <AlertTriangle class="w-10 h-10 text-error" />
      </div>
      <h1 class="heading-page mb-2">
        Terjadi Masalah
      </h1>
      <p class="text-text-muted font-medium mb-8 leading-relaxed">
        Terjadi masalah yang tidak terduga. Silakan muat ulang halaman.
      </p>
      <BaseButton
        variant="primary"
        size="md"
        block
        @click="handleReload"
      >
        Muat Ulang
      </BaseButton>
    </div>
  </div>
  <slot v-else :key="componentKey" />
</template>
